<template>
  <div class="container">
    <el-row v-if="!notFound" v-loading="loadStatus">
      <el-col :span="24">
        <el-row class="information-box">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-row>
              <el-col :xs="24" :sm="12" class="">
                <div class="titulo">
                  INFORMACIÓN CLIENTE
                </div>
                <div
                  v-for="(value, key) in informacionCliente"
                  v-bind:key="key"
                  class = "box-info-style">
                  <div class= "value-style">
                    {{ value }}
                  </div>
                  <div class = "key-style">
                    <template v-if="key !== 'estado'">
                      {{ key.toUpperCase() }}
                    </template>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" class="">
                <div class="titulo">
                  INFORMACIÓN CONDUCTOR
                </div>
                <div
                  v-for="(value, key) in informacionChofer"
                  v-bind:key="key"
                  class = "box-info-style">
                  <div v-if="key === 'patente'" class= "value-style">
                    {{ value }}
                  </div>
                  <div v-else class= "value-style">
                    {{ value }}
                  </div>
                  <div class = "key-style">
                    {{ key.toUpperCase() }}
                  </div>
                </div>
                <button type="button" class="download-btn" v-on:click="download">Descargar Historico</button>
                <button
                  type="button"
                  class="download-btn box-btn"
                  :disabled="!suborderForBox"
                  v-on:click="showBoxModal = true">Ver paquete</button>

              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" class="mapa-box">
            <route-map
              :clickedId="routePosition"
              :zoom="18"
              :lat="lat"
              :lon="lon"
              :index="dp_id"
              :suborder="dataClient"
              height="300px"></route-map>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <pickUpInfo
              v-if="show"
              :pickUpInfo="packagesList"
              :showBtn="false" />
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div v-if="notFound">
      <notFound
        imgName="fb-box.svg"
        :textGreen="'No se encontró'"
        :textGrey="'el nº de orden asociado'" />
    </div>
    <tracing-suborder-box
      :visible.sync="showBoxModal"
      :suborderId="suborderForBox" />
  </div>
</template>

<script>
import { decodeRSA } from '../../mixins/function';
import RouteMap from './maps/MapSuborderInfo.vue';
import PickUpInfo from './TracingPickUpInfo.vue';
import NotFound from './Base404.vue';
import TracingSuborderBox from './TracingSuborderBox.vue';
import XLSX from "xlsx";

export default {
  props: {
    dataClient: {
      type: Object,
    },
    routes: {
      type: Array,
    },
    notFound: {
      type: Boolean,
    },
  },
  components: {
    pickUpInfo: PickUpInfo,
    'route-map': RouteMap,
    notFound: NotFound,
    'tracing-suborder-box': TracingSuborderBox,
  },
  filters: {
    applyDecodeRSA(data) {
      return decodeRSA(data);
    },
  },
  data() {
    return {
      // clientIdOnRoute: 0,
      clientLatLong: [],
      lat: -33.435774,
      lon: -70.660690,
      dp_id: 0,
      firstLoad: false,
      loadStatus: false,
      suborderMap: {},
      routesOrdenadas: null,
      informacionCliente: {
        nombre: '',
        telefono: '',
        rut: '',
        direccion: '',
        eta: '',
        punto: '',
      },
      informacionChofer: {
        nombre: '',
        rut: '',
        telefono: '',
        empresa: '',
        patente: '',
      },
      informacionPaquete: {
        suborden: '',
        f12: '',
        paquetes: '',
      },
      items: {
        item1: '',
        item2: '',
      },
      packagesList: {
        labelOne: '#',
        labelTwo: 'SUB ORDEN',
        labelThree: 'F12',
        labelFour: 'ESTADO',
        labelFive: 'MOTIVO',
        labelSix: 'PRODUCTO',
        labelSixWidth: '400',
        list: [],
        show: true,
      },
      charge: false,
      show: true,
      routePosition: 0,
      showBoxModal: false,
    };
  },
  computed: {
    suborderForBox() {
      const suborder = this.dataClient && this.dataClient.suborder;
      if (!suborder) return null;
      return suborder.code || suborder.id || null;
    },
  },
  methods: {
    download : function() {
      const data = XLSX.utils.json_to_sheet(this.dataClient.report)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data, 'data')
      console.log(this.dataClient.suborder.code)
      XLSX.writeFile(wb,"export-"+this.dataClient.suborder.code+'.xlsx')
    },
    setClientInfo() {
      this.routePosition = this.dataClient.route_position + 1;
      this.clientLatLong = [this.dataClient.point.latitude, this.dataClient.point.longitude];
      // información del mapa
      this.charge = true;
      // cliente
      this.informacionCliente.nombre = decodeRSA(this.dataClient.customer.full_name);
      this.informacionCliente.telefono = decodeRSA(this.dataClient.customer.phone);
      this.informacionCliente.rut = decodeRSA(this.dataClient.customer.rut);
      this.informacionCliente.eta = this.setDateToTime(
        {
          date: this.dataClient.estimated_at,
        },
      );
      this.informacionCliente.direccion = this.setAddress(this.dataClient);
      this.informacionCliente.punto = this.dataClient.route_position + 1;
      // this.dataClient.suborders.packages[0].last_state.state_type.type;
      // chofer
      this.informacionChofer.nombre = `${decodeRSA(this.dataClient.driver.first_name)} ${decodeRSA(this.dataClient.driver.last_name)}`;
      this.informacionChofer.telefono = this.dataClient.driver.phone;
      this.informacionChofer.rut = decodeRSA(this.dataClient.driver.rut);
      this.informacionChofer.patente = this.dataClient.vehicle.patent;
      this.informacionChofer.empresa = this.dataClient.driver.enterprise.name;
      this.setProducts();
    },
    setProducts() {
      this.packagesList.list = [];
      this.dp_id = this.dataClient.route_position;
      const productList = this.dataClient.suborder.packages;
      productList.forEach((element) => {
        const oneProduct = {};
        oneProduct.labelTwo = this.dataClient.suborder.code;
        // eslint-disable-next-line max-len
        if ((this.dataClient.suborder.first_do != null) && (this.dataClient.suborder.first_do !== 0)) {
          oneProduct.labelThree = this.dataClient.suborder.first_do;
        } else {
          oneProduct.labelThree = this.dataClient.suborder.do;
        }
        oneProduct.labelFour = this.dataClient.state.state_type.id;
        oneProduct.labelSix = element.description;
        this.packagesList.list.push(oneProduct);
      });
    },
    setAddress(row) {
      if (row.point.street.name === '') {
        return `${decodeRSA(row.raw_address)}, ${row.point.street.commune.name}`;
      }
      return `${decodeRSA(row.point.street.name)} ${row.point.street_number}, ${row.point.street.commune.name}`;
      // return `${row.street.name} ${row.street_number}`;
    },
    setDateToTime({ date }) {
      if (date) {
        const aux = new Date(date);
        const hour = aux.getHours() < 10 ? `0${aux.getHours().toString()}` : aux.getHours();
        const minutes = aux.getMinutes() < 10 ? `0${aux.getMinutes().toString()}` : aux.getMinutes();
        const seconds = aux.getSeconds() < 10 ? `0${aux.getSeconds().toString()}` : aux.getSeconds();
        return `${hour}:${minutes}:${seconds}`;
      }
      return '---';
    },
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  watch: {
    routes() {
      if (this.charge === true) {
        this.setProducts();
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
        });
      }
      this.firstLoad = true;
      this.loadStatus = false;
    },
    dataClient() {
      this.setClientInfo();
    },
  },
};
</script>

<style scoped>
  .container {
    box-sizing: border-box;
  }
  .information-box {
    justify-content: normal;
  }
  .value-style{
    font-weight: 300;
    font-size: 14px;
    text-transform: uppercase;
    color: #707070;
  }
  .key-style {
    font-weight: 500;
    font-size: 10px;
    color: #AAD500;
    margin-bottom: 1em;
  }
  .box-info-style {
    text-align: left;
  }
  .information-style {
    display: flex;
    flex-direction: column;
  }
  .driver-style {
    min-width: 50%;
  }
  .titulo {
    font-size: 17px;
    text-align: justify;
    margin-bottom: 1em;
    color: #9B9B9B;
  }
  .information-style .titulo {
    margin-bottom: 1.5em;
  }
  .container-info{
    margin-left: 0%;
  }
  .linkStyle{
    color: #AAD500;
    border: none;
    font-weight: 600;
    font-size: 15px;
    outline: none;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.0);
    margin: 0;
    padding: 0;
  }
  .mapa-box {
    margin-bottom: 2em;
  }
  .box-btn {
    margin-left: 8px;
  }
</style>
